import { schema } from 'normalizr'

export type Comment = {
  id: number
  parent: number | null | undefined
  author: {
    id: number
    name: string
    image: string
    groups: Array<string>
  }
  deleted: boolean
  created_at: string
  edited_at: string
  moderated_at: string
  text: string
  responses: Array<Comment>
  content_type: string
  object_id: number
}

export const commentSchema = new schema.Entity('comments')
export const commentListSchema = [commentSchema]
